import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaWhatsapp, FaYoutube, FaTiktok, FaFacebook, FaInstagram } from 'react-icons/fa6';

const logo = process.env.PUBLIC_URL + '/logo.png';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="container mx-auto px-4 py-10 text-center">
        <img src={logo} alt="FreeSekho" className="mx-auto h-12 mb-6" loading="lazy" decoding="async" />
        <div className="flex items-center justify-center gap-3 mb-6">
          <a href="https://api.whatsapp.com/send?phone=03105245223&text=Hello%20Sir%2C%20please%20add%20me%20to%20the%20group" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ backgroundColor: '#25D366' }}>
            <FaWhatsapp className="w-6 h-6" />
          </a>
          <a href="https://youtube.com/@freesekhoo?si=PVuvM3YFPzpYiKbZ" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ backgroundColor: '#FF0000' }}>
            <FaYoutube className="w-5 h-5" />
          </a>
          <a href="https://www.instagram.com/freesekhoo?igsh=NzVlMGU2ZjdzYTk5" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ backgroundColor: '#E4405F' }}>
            <FaInstagram className="w-5 h-5" />
          </a>
          <a href="https://www.tiktok.com/@freesekhoo?_r=1&_t=ZS-9275aKKekgZ" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ backgroundColor: '#000000' }}>
            <FaTiktok className="w-5 h-5" />
          </a>
          <a href="https://www.facebook.com/share/18V3qgNSmE/" target="_blank" rel="noopener noreferrer" className="social-icon" style={{ backgroundColor: '#1877F2' }}>
            <FaFacebook className="w-5 h-5" />
          </a>
        </div>
        <div className="flex items-center justify-center flex-wrap gap-x-6 gap-y-2 text-sm uppercase tracking-wide mb-4">
          <Link to="/about" className="footer-link">About Us</Link>
          <Link to="/contact" className="footer-link">Contact Us</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
          {/* <Link to="/quiz" className="footer-link">Quizzes</Link>
          <Link to="/past-papers" className="footer-link">Past Papers</Link>
          <Link to="/mcqs" className="footer-link">MCQs</Link> */}
        </div>
        <div className="text-gray-300 text-sm max-w-3xl mx-auto mb-4">
          FreeSekho is a free learning platform providing high-quality notes, lectures, and complete government job preparation, including PPSC, FPSC, CSS, PMS, SPSC, and KPSC.
        </div>
        <div className="text-gray-400 text-xs">&copy; {new Date().getFullYear()} FreeSeekho.com</div>
      </div>
    </footer>
  );
};

export default Footer;
